export default "__VITE_ASSET__BiECeEYp__"